import React, { Fragment } from "react";
import { Router, Route, Redirect } from "react-router";

import TeamDeskNew from "./components/TeamDesk/TeamDeskNew.react";

import FourOhFour from "./components/FourOhFour/FourOhFour.react";
import Login from "./dashboard/Login/Login.react";
import Activation from "./dashboard/Login/AccountActivation.react";
import AccountInfo from "./dashboard/Account/AccountInfo.react";
import AccountInfoUpdate from "./dashboard/Account/AccountInfoUpdate.react";
import AccountLegalCompliance from "./dashboard/Account/AccountLegalCompliance.react";
import UpdateEURepresentative from "./dashboard/Account/UpdateEURepresentative.react";
import UpdateDPO from "./dashboard/Account/UpdateDPO.react";
import AccountStaticPageExport from "./dashboard/Account/StaticPages/Export.react";
import AccountStaticPageWithdraw from "./dashboard/Account/StaticPages/Withdraw.react";
import AccountStaticPageForgot from "./dashboard/Account/StaticPages/Forgot.react";
import AccountActivity from "./dashboard/Account/AccountActivity.react";
import AccountSecurity from "./dashboard/Account/AccountSecurity.react";
import BackupsActivation from "./dashboard/Backup/BackupsActivation.react";
import Referrals from "./dashboard/Referrals/Referrals.react";
import Billing from "./dashboard/Billing/Billing.react";
import UpdateBillingInfo from "./dashboard/Billing/UpdateBillingInfo.react";
import DefaultView from "./dashboard/DefaultView.react";
import CreditCard from "./dashboard/Billing/CreditCard.react";
import AppsDetails from "./dashboard/Billing/AppsDetails.react";
import ApiConsole from "./dashboard/Data/ApiConsole/ApiConsole.react";
import AppData from "./dashboard/AppData.react";
import AppsIndex from "./dashboard/Apps/AppsIndex.react";
import Registration from "./dashboard/Login/Registration.react";
import Browser from "./dashboard/Data/Browser/Browser.react";
import CloudCode from "./dashboard/Data/CloudCode/CloudCode.react";
import Config from "./dashboard/Data/Config/Config.react";
import GeneralSettings from "./dashboard/Settings/GeneralSettings.react";
import EmailsSettings from "./dashboard/Settings/EmailsSettings.react";
import EmailsTemplatesLocalization from "./dashboard/Settings/Emails/EmailsTemplatesLocalization.react";
import LiveQueriesSettings from "./dashboard/Settings/LiveQueriesSettings.react";
import JobEdit from "./dashboard/Data/Jobs/JobEdit.react";
import Jobs from "./dashboard/Data/Jobs/Jobs.react";
import JobsData from "./dashboard/Data/Jobs/JobsData.react";
import Logs from "./dashboard/Data/Logs/Logs.react";
import MigrationAnimation from "./dashboard/ParseGroundMigration/MigrateAppAnimation.react";
import WhatsNext from "./dashboard/ParseGroundMigration/WhatsNext.react";
import DBRestore from "./dashboard/Backup/DBRestore.react";
import Create from "./dashboard/CreateApp/CreateApp.react";
import PushAudiencesIndex from "./dashboard/Push/PushAudiencesIndex.react";
import PushDetails from "./dashboard/Push/PushDetails.react";
import PushIndex from "./dashboard/Push/PushIndex.react";
import PushNew from "./dashboard/Push/PushNew.react";
import PushSettings from "./dashboard/Settings/PushSettings.react";
import SecuritySettings from "./dashboard/Settings/SecuritySettings.react";
import RuntimeVersion from "./dashboard/Runtime/Version.react";
import RuntimeEnvVariables from "./dashboard/Runtime/EnvVariables.react";
import EngineView from "./dashboard/Runtime/Engine.react";
import BuildsView from "./dashboard/Runtime/Builds.react";
import BuildLogView from "./dashboard/Runtime/BuildLog.react";
import DeploymentsView from "./dashboard/Runtime/Deployments.react";
import SettingsData from "./dashboard/Settings/SettingsData.react";
import UsersSettings from "./dashboard/Settings/UsersSettings.react";
import Webhooks from "./dashboard/Data/Webhooks/Webhooks.react";
import MetricsData from "./dashboard/Metrics/MetricsData.react";
import MetricsRequests from "./dashboard/Metrics/Requests.react";
import MetricsTraffic from "./dashboard/Metrics/Traffic.react";
import MetricsDatabase from "./dashboard/Metrics/Database.react";
import MetricsFiles from "./dashboard/Metrics/Files.react";
import AppOverview from "./dashboard/Metrics/Overview.react";
import EngineDetails from "./dashboard/Metrics/EngineDetails.react";
import AppBackupList from "./dashboard/Backup/BackupList.react";
import DatabaseRestoreHistory from "./dashboard/Backup/RestoreHistory.react";
import DatabaseDownloadHistory from "./dashboard/Backup/DownloadHistory.react";

import CDNServiceData from "./dashboard/CDN/Data.react";
import CDNServiceOverview from "./dashboard/CDN/Overview.react";
import CDNServiceActivate from "./dashboard/CDN/ServiceActivate/ServiceActivate.react";
import CDNServiceCreate from "./dashboard/CDN/Create/Create.react";
import CDNServiceSiteData from "./dashboard/CDN/Site/Data.react";
import CDNServiceSiteOverview from "./dashboard/CDN/Site/Overview.react";
import CDNServiceSiteSettings from "./dashboard/CDN/Site/Settings.react";
import CDNServiceSiteManageCache from "./dashboard/CDN/Site/ManageCache.react";

const Entry = props => {
  return (
    <Fragment>
      <AppsIndex dashboard {...props} />
      {props.children}
    </Fragment>
  );
};

const Routes = props => {
  const pathName = props.history.getCurrentLocation().pathname;
  if (pathName.startsWith("/apps")) {
    window.location = pathName.replace("/apps", "/products/apps");
    return null;
  }

  const AppsIndexPage = () => {
    return <DefaultView section="Products" subsection="Apps" {...props} />;
  };

  const AddPropsToRoute = (Composed, passedProps, widthDefaultView) => {
    return p => {
      const newPassedProps = Object.assign({ ...props }, p, passedProps);

      if (widthDefaultView) {
        return (
          <DefaultView {...newPassedProps}>
            <Composed {...newPassedProps} />
          </DefaultView>
        );
      }

      return <Composed {...newPassedProps} />;
    };
  };

  const activationCheck = (nextState, replace) => {
    if (!props.currentUser.cdn_enabled) {
      // if (props.currentUser.cdn_enabled) {
      replace({ pathname: "/products/cdn/activate" });
      return true;
    }
    return false;
  };

  return (
    <>
      <TeamDeskNew />
      <Router history={props.history}>
        <Redirect from="/" to="/products" />
        <Redirect from="/apps" to="/products/apps" />
        <Route path="/" component={(p) => <Entry {...props} {...p} />} breadcrumbIgnore>
          <Route path="/login" component={Login} />
          <Route path="/register" component={Registration} />
          <Route path="/register/ref/:referral_code" component={Registration} />
          <Route
            path="/forgot/:forgot/activate/:activation"
            component={Activation}
          />
          <Route path="/activate/:activation" component={Activation} />

          <Route path="/tickets/new" component={AppsIndexPage} />

          <Redirect from="products" to="/products/apps" />
          <Route exact path="/products/apps" component={AppsIndexPage} />

          <Redirect
            from="/products/apps/:appId"
            to="/products/apps/:appId/browser"
          />
          <Route
            path="/products/apps/:appId"
            component={AddPropsToRoute(AppData)}
          >
            <Route path="getting-started" component={WhatsNext} />

            <Redirect
              from="metrics"
              to="/products/apps/:appId/metrics/overview"
            />
            <Route path="metrics" component={MetricsData}>
              <Route path="overview" component={AppOverview} />
              <Route path="engine" component={EngineDetails} />
              <Route path="engine" component={EngineDetails} />
              <Route path="requests" component={MetricsRequests} />
              <Route path="traffic" component={MetricsTraffic} />
              <Route path="database" component={MetricsDatabase} />
              <Route path="files" component={MetricsFiles} />
            </Route>

            <Route exact path="browser" component={Browser} />
            <Route exact path="browser/:className" component={Browser} />
            <Route
              exact
              path="browser/:className/:entityId/:relationName"
              component={Browser}
            />

            <Route path="cloud_code" component={CloudCode} />
            <Route path="cloud_code/**" component={CloudCode} />
            <Route path="webhooks" component={Webhooks} />

            <Redirect from="jobs" to="/products/apps/:appId/jobs/scheduled" />
            <Route path="jobs" component={JobsData}>
              <Route path="new" component={JobEdit} />
              <Route path="edit/:jobId" component={JobEdit} />
              <Route path=":section" component={Jobs} />
            </Route>

            <Redirect from="logs" to="/products/apps/:appId/logs/all" />
            <Route path="logs/:type" component={Logs} />
            <Route path="config" component={Config} />

            <Redirect
              from="api-console"
              to="/products/apps/:appId/api-console/rest"
            />
            <Route path="api-console/:type" component={ApiConsole} />

            <Route path="creation" component={MigrationAnimation} />
            <Route path="next" component={WhatsNext} />

            <Route path="db-restore" component={DBRestore} />
            <Redirect from="backups" to="/products/apps/:appId/backup/list" />
            <Route path="backups" component={SettingsData}>
              <Route path="list" component={AppBackupList} />
              <Route
                path="restore_history"
                component={DatabaseRestoreHistory}
              />
              <Route
                path="download_history"
                component={DatabaseDownloadHistory}
              />
            </Route>

            <Redirect
              from="push"
              to="'/products/apps/:appId/push/activity/all"
            />
            <Redirect
              from="push/activity"
              to="/products/apps/:appId/push/activity/all"
            />
            <Route path="push/activity/:category" component={PushIndex} />
            <Route path="push/audiences" component={PushAudiencesIndex} />
            <Route path="push/new" component={PushNew} />
            <Route path="push/:pushId" component={PushDetails} />

            <Redirect
              from="runtime"
              to="/products/apps/:appId/runtime/engine"
            />
            <Route path="runtime" component={SettingsData}>
              <Route path="version" component={RuntimeVersion} />
              <Route path="env-variables" component={RuntimeEnvVariables} />
              <Route path="engine" component={EngineView} />
              <Route exact path="builds" component={BuildsView} />
              <Route path="builds/:buildId/log" component={BuildLogView} />
              <Route path="deployments" component={DeploymentsView} />
            </Route>

            <Redirect
              from="settings"
              to="/products/apps/:appId/settings/general"
            />
            <Route path="settings" component={SettingsData}>
              <Route path="general" component={GeneralSettings} />
              <Route path="keys" component={SecuritySettings} />
              <Route path="users" component={UsersSettings} />
              <Route path="push" component={PushSettings} />
              <Route path="emails" component={EmailsSettings} />
              <Route
                path="emails/templates/:langTag"
                component={EmailsTemplatesLocalization}
              />
              <Route path="live_queries" component={LiveQueriesSettings} />
            </Route>
          </Route>

          <Route path="create" component={AddPropsToRoute(Create)} />

          <Redirect from="/account" to="/account/info" />
          <Route
            path="account/info"
            component={AddPropsToRoute(
              AccountInfo,
              { section: "Account", subsection: "Info" },
              true
            )}
          />
          <Route
            path="account/info/update"
            component={AddPropsToRoute(
              AccountInfoUpdate,
              { section: "Account", subsection: "Info" },
              true
            )}
          />
          <Route
            path="account/info/export"
            component={AddPropsToRoute(
              AccountStaticPageExport,
              { section: "Account", subsection: "Info" },
              true
            )}
          />
          <Route
            path="account/info/withdraw"
            component={AddPropsToRoute(
              AccountStaticPageWithdraw,
              { section: "Account", subsection: "Info" },
              true
            )}
          />
          <Route
            path="account/info/forgot"
            component={AddPropsToRoute(
              AccountStaticPageForgot,
              { section: "Account", subsection: "Info" },
              true
            )}
          />
          <Route
            path="account/legal"
            component={AddPropsToRoute(
              AccountLegalCompliance,
              { section: "Account", subsection: "Legal & Compliance" },
              true
            )}
          />
          <Route
            path="account/legal/EURepresentative/update"
            component={AddPropsToRoute(
              UpdateEURepresentative,
              { section: "Account", subsection: "Legal & Compliance" },
              true
            )}
          />
          <Route
            path="account/legal/DPO/update"
            component={AddPropsToRoute(
              UpdateDPO,
              { section: "Account", subsection: "Legal & Compliance" },
              true
            )}
          />
          <Route
            path="account/activity"
            component={AddPropsToRoute(
              AccountActivity,
              { section: "Account", subsection: "Activity" },
              true
            )}
          />
          <Route
            path="account/security"
            component={AddPropsToRoute(
              AccountSecurity,
              { section: "Account", subsection: "Security" },
              true
            )}
          />

          <Route
            path="backups"
            component={AddPropsToRoute(
              BackupsActivation,
              { section: "Automatic Database Backups" },
              true
            )}
          />

          <Redirect from="invite" to="/referrals" />
          <Route
            path="referrals"
            component={AddPropsToRoute(
              Referrals,
              { section: "Referrals" },
              true
            )}
          />

          <Redirect from="billing" to="/billing/info" />
          <Route path="billing">
            <Route
              path="info"
              component={AddPropsToRoute(Billing, { section: "Billing" }, true)}
            />
            <Route
              path="info/update"
              component={AddPropsToRoute(
                UpdateBillingInfo,
                { section: "Billing" },
                true
              )}
            />
            <Route
              path="add_card"
              component={AddPropsToRoute(
                CreditCard,
                { section: "Billing", view: "addCard" },
                true
              )}
            />
            <Route
              path="edit_card"
              component={AddPropsToRoute(
                CreditCard,
                { section: "Billing", view: "editCard" },
                true
              )}
            />
            <Route
              path="apps_details"
              component={AddPropsToRoute(
                AppsDetails,
                { section: "Billing" },
                true
              )}
            />
          </Route>

          <Redirect from="/products/cdn" to="/products/cdn/overview" />
          <Route
            path="/products/cdn"
            breadcrumbName="CDN"
            component={AddPropsToRoute(
              CDNServiceData,
              { section: "Products", subsection: "CDN" },
              true
            )}
          >
            <Route
              path="activate"
              name="Activate CDN"
              component={CDNServiceActivate}
              breadcrumbIgnore
            />
            <Route
              path="overview"
              name="Overview"
              onEnter={activationCheck}
              component={CDNServiceOverview}
              breadcrumbIgnore
            />
            <Route
              path="create"
              name="Create CDN"
              onEnter={activationCheck}
              component={CDNServiceCreate}
              breadcrumbIgnore
            />

            <Redirect
              from="/products/cdn/:cdnId"
              to="/products/cdn/:cdnId/overview"
            />
            <Redirect
              from="/products/cdn/:cdnId/settings"
              to="/products/cdn/:cdnId/settings/edit"
            />
            <Route
              path=":cdnId"
              breadcrumbName=":cdnId"
              onEnter={activationCheck}
              component={CDNServiceSiteData}
            >
              <Route
                path="overview"
                name="Overview"
                component={CDNServiceSiteOverview}
              />
              <Route path="settings" name="Settings" breadcrumbName="Settings">
                <Route
                  path="edit"
                  name="Edit"
                  component={CDNServiceSiteSettings}
                />
                <Route
                  path="manage_cache"
                  name="Manage Cache"
                  component={CDNServiceSiteManageCache}
                />
              </Route>
            </Route>

            {
              // <Redirect from="/products/cdn/:cdnId" to="/products/cdn/:cdnId/overview" />
              // <Route path="/products/cdn/:cdnId">
              // </Route>
            }
          </Route>
        </Route>
        <Route path="*" component={FourOhFour} />
      </Router>
    </>
  );
};

export default Routes;
